module.exports = "https://r.nearpod.com/assets/media/image/sway-5b52ac9dfe893aec3c1b6f4522ad2f32.svg";